import { render, staticRenderFns } from "./OverrideStrategyConfig.vue?vue&type=template&id=6d589a70"
import script from "./OverrideStrategyConfig.vue?vue&type=script&lang=js"
export * from "./OverrideStrategyConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports